import { FilterMatchMode } from "primereact/api";

export class ProyectoPrincipal {

    model = {
        id: {
            value: null,
            export: true,
            header: 'Código',
            table: false,
            filter: true,
            filterPlaceholder: 'Buscar por código',
            filterField: 'id',
            sort: true,
            matchMode: FilterMatchMode.EQUALS,
            showFilterMatchModes: false,
            headerStyle: { width: '10%', minWidth: '10rem' }
        },
        nombre_empresa: {
            value: '',
            export: true,
            header: 'Nombre de la empresa o persona natural',
            table: true,
            sort: false,
            filter: true,
            headerStyle: { width: '30%', minWidth: '20rem' },
            filterPlaceholder: 'Buscar',
            filterField: 'nombre_empresa',
            matchMode: FilterMatchMode.CONTAINS,
            required: 'Campo requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 300,
            min: 4,
        },
        descripcion: {
            value: '',
            export: true,
            header: 'Descripción del proyecto o servicio',
            table: true,
            sort: false,
            filter: true,
            headerStyle: { width: '50%', minWidth: '20rem' },
            filterPlaceholder: 'Buscar',
            filterField: 'descripcion',
            matchMode: FilterMatchMode.CONTAINS,
            required: 'Campo requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 300,
            min: 4,
        },
        anio: {
            value: null,
            export: false,
            header: 'Año en el que se realizó:',
            maxLength: 'Máximo 40 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 2100,
            min: 1900,
            required: 'Año requerido'
        },
    }
}